import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UserQualificationV2History } from '@wilson/interfaces';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { QualificationVersionListComponent } from '../../../../qualification-version-list/qualification-version-list.component';

@Component({
  selector: 'wilson-user-qualification-v2-details-history-section',
  imports: [NzCollapseModule, TranslatePipe, QualificationVersionListComponent],
  templateUrl: './user-qualification-v2-details-history-section.component.html',
  styleUrl: './user-qualification-v2-details-history-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserQualificationV2DetailsHistorySectionComponent {
  @Input() userQualificationHistories!:
    | UserQualificationV2History[]
    | undefined;
}
